export default __webpack_public_path__ + "static/media/block-1.990c3f11.png";